import React, { useEffect, useState } from 'react';

export default function Avatar({ userId, clanId, src, alt = '', ...props }) {
  const safe = src && !src.includes('api.telegram.org/file/bot') ? src : null;
  const [url, setUrl] = useState(safe);
  const [failed, setFailed] = useState(false);
  useEffect(() => { setUrl(safe); setFailed(false); }, [safe]);
  useEffect(() => {
    if ((!clanId && safe && !failed) || (!userId && !clanId)) return;
    let active = true;
    fetch(`${process.env.REACT_APP_API_URL}/avatars/${clanId ? 'clan' : 'user'}/${clanId || userId}${failed ? '?refresh=1' : ''}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => { if (active && data?.photoUrl) setUrl(data.photoUrl); })
      .catch(() => {});
    return () => { active = false; };
  }, [userId, clanId, failed, safe]);
  return <img {...props} src={url || '/assets/imgur/C3a3S1X.png'} alt={alt} onError={() => { setUrl(null); setFailed(true); }} />;
}
